exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dicono-di-noi-js": () => import("./../../../src/pages/dicono-di-noi.js" /* webpackChunkName: "component---src-pages-dicono-di-noi-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-spettacoli-js": () => import("./../../../src/pages/spettacoli.js" /* webpackChunkName: "component---src-pages-spettacoli-js" */),
  "component---src-templates-play-js": () => import("./../../../src/templates/play.js" /* webpackChunkName: "component---src-templates-play-js" */)
}

